import { useSelector } from "react-redux";
import { selectActors } from "../../../app/slices/TrainingSlice";
import OutfitPickerField from "../../outfit_picker/OutfitPickerField";
import { ISetOutfit } from "../../../models/interactions/SetOutfit";
import Interaction from "../../../models/interactions/Interaction";
import NodeActorDropdown from "../components/NodeActorDropdown";
import useUpdateSequenceInteraction from "./UpdateSequenceInteraction.hook";

export default function SetOutfitNodePreview(props: {
  nodeId: string;
  interaction: Interaction;
}) {
  const setOutfit = props.interaction as ISetOutfit;
  const { updateInteraction } = useUpdateSequenceInteraction();
  const actors = useSelector(selectActors);

  const actorDropdown = (
    <NodeActorDropdown
      label="Actor"
      selectedActorId={setOutfit.actorId}
      onClick={(actorId: string) =>
        updateInteraction(props.nodeId, {
          ...setOutfit,
          actorId: actorId,
        } as ISetOutfit)
      }
    />
  );

  const outfitDropdown = (
    <OutfitPickerField
      context="setOutfit"
      actor={actors.find((actor) => actor.id === setOutfit.actorId)}
      value={setOutfit.outfitName ?? ""}
      onChange={(outfitName) =>
        updateInteraction(props.nodeId, {
          ...setOutfit,
          outfitName: outfitName,
        } as ISetOutfit)
      }
      className="w-full"
    />
  );

  return (
    <div className="w-full h-full flex flex-col gap-[4px]">
      {actorDropdown}
      {outfitDropdown}
    </div>
  );
}
